module.exports = __webpack_public_path__ + "img/payment-failed.7c7cd0bc.png";